import { useState } from 'react';
import { UploadXmlUseCase } from '../../application/useCases';
import { useApp } from '../contexts';

export const useXmlUpload = (token: string | null) => {
    const { showError, showSuccess } = useApp();
    const [xmlAttachedTransactions, setXmlAttachedTransactions] = useState<Set<number>>(new Set());

    const uploadXml = async (file: File, transactionId: number): Promise<boolean> => {
        if (!token) {
            showError('Token não encontrado. Por favor, recarregue a página.');
            return false;
        }

        const validTypes = ['text/xml', 'application/xml', 'application/xhtml+xml'];
        const isValidType = validTypes.includes(file.type) || file.name.toLowerCase().endsWith('.xml');

        if (!isValidType) {
            showError('Por favor, selecione um arquivo XML válido.');
            return false;
        }

        try {
            const useCase = new UploadXmlUseCase();
            const xmlContent = await useCase.execute(file);
            
            const normalizedXml = xmlContent
                .replace(/\r\n/g, '')
                .replace(/\n/g, '')
                .replace(/\r/g, '')
                .replace(/>\s+</g, '><')
                .trim();
            
            await useCase.uploadToTransaction(transactionId, normalizedXml, token);
            
            setXmlAttachedTransactions(prev => new Set(prev).add(transactionId));
            showSuccess('XML anexado com sucesso!');
            return true;
        } catch (error) {
            const message = error instanceof Error ? error.message : 'Erro ao enviar XML';
            showError(message);
            return false;
        }
    };

    return {
        uploadXml,
        xmlAttachedTransactions,
    };
};

